import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GlobalSupplierService } from '../global-supplier/global-supplier.service';

/**
 * Lets a page open only when its application is enabled for the global supplier,
 * otherwise redirects to the landing page
 */
@Injectable()
export class GlobalSupplierGuardService implements CanActivateChild {
  constructor(private globalSupplierService: GlobalSupplierService, private router: Router) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const path = this.globalSupplierService.pagePath(state.url);
    if (this.globalSupplierService.isPageEnabled(path)) {
      return true;
    }

    return this.router.parseUrl(this.globalSupplierService.landingPage());
  }
}
